<footer class="footer bg-primary-500">
  <div class="footer-content">
    <!-- Company Info -->
    <div class="footer-section">
      <h2>XEDOOM</h2>
      <p class="company-description">
        {{ 'footer.company_description' | translate | async }}
      </p>
      <div class="social-links">
        <a *ngFor="let social of socialLinks"
           [href]="social.url"
           target="_blank"
           rel="noopener noreferrer"
           [attr.aria-label]="social.labelKey | translate | async"
           mat-icon-button>
          <img [src]="social.icon" [alt]="social.labelKey | translate | async">
        </a>
      </div>
    </div>

    <!-- Quick Links -->
    <div class="footer-section">
      <h3>{{ 'footer.sections.quick_links' | translate | async }}</h3>
      <nav class="footer-nav">
        <a *ngFor="let link of companyLinks"
           [routerLink]="link.path"
           class="footer-link">
          {{ link.labelKey | translate | async }}
        </a>
      </nav>
    </div>

    <!-- About -->
    <div class="footer-section">
      <h3>{{ 'footer.sections.about' | translate | async }}</h3>
      <nav class="footer-nav">
        <a *ngFor="let link of aboutLinks"
           [routerLink]="link.path"
           class="footer-link">
          {{ link.labelKey | translate | async }}
        </a>
      </nav>
    </div>

    <!-- Legal -->
    <div class="footer-section">
      <h3>{{ 'footer.sections.legal' | translate | async }}</h3>
      <nav class="footer-nav">
        <a *ngFor="let link of legalLinks"
           [routerLink]="link.path"
           class="footer-link">
          {{ link.labelKey | translate | async }}
        </a>
      </nav>
    </div>
  </div>

  <!-- Copyright -->
  <div class="footer-bottom">
    <p class="copyright">
      © {{currentYear}} XEDOOM. All rights reserved.
    </p>
    <p class="copyright">
      Alvakos LLC, Hollywood FL, USA
    </p>
  </div>
</footer>
